'use client';

import { FC } from 'react';
export interface ThreeColumnMediaFullProps {
  title: React.ReactNode,
  features: {
    icon: React.ReactNode,
    title: string;
    description: string | JSX.Element;
  }[]
  mainImage: React.ReactNode;
}

const ThreeColumnMediaFull: FC<ThreeColumnMediaFullProps> = ({

  title,
  features = [],
  mainImage,

}) => {
  return (
    <div className="bg-white text-white">
      <div className="-mt-header-height-mobile md:-mt-header-height-desktop pt-header-height-mobile md:pt-header-height-desktop">
        <div className="pt-0 md:pt-12 px-container-mobile md:px-container-desktop mx-auto max-w-grid">
          <div className="grid gap-2 md:gap-3 text-left">
            <div className="flex justify-center">
              <h1 className="text-blue-900 text-25/33 md:text-43/53 font-500 max-w-[700px] text-left md:text-center mb-[48px] md:mb-[64px]">{title}</h1>
            </div>
            <div className="flex justify-between flex-wrap md:flex-nowrap">
              {features.map((item, index) => {
                return (
                  <div key={`feature-card-${index}`} className="flex flex-wrap w-full md:max-w-[344px] mb-[32px] mr-[16px] md:mb-0">
                    <div className="flex">
                      <div className="flex" id="icon">
                        <span className="flex w-[32px] h-[32px] bg-citron-500 rounded-[50%] justify-center items-center mr-[16px]">
                          {item.icon}
                        </span>
                      </div>
                      <div className="flex text-21/31 text-blue-900 font-500" id="textHeader">
                        {item.title}
                      </div>
                    </div>
                    <div className="flex text-17/27 text-gray-700 mt-[18px]">
                      {item.description}
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
          <div className="flex justify-center w-auto md:w-full pt-0 md:pt-[76px] mt-[64px]">
            {mainImage}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThreeColumnMediaFull;
